import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Card } from "../components/ui/card";
import { toast } from "sonner";
import GoogleSignInButton from "../components/GoogleSignInButton";

export default function LoginPage() {
  const [params] = useSearchParams();

  useEffect(() => {
    const err = params.get("error");
    if (err) toast.error(`Connexion échouée : ${err.replace(/^google_/, "")}`);
  }, [params]);

  return (
    <div className="sm:min-h-[calc(100vh-4rem)] grid place-items-center px-6 py-10 sm:py-12 grid-noise">
      <Card className="w-full max-w-md p-8 bg-card border-white/5" data-testid="login-card">
        <div className="flex flex-col items-center mb-6 text-center">
          <img src="/logo-sideb.png" alt="Side B" className="h-14 w-auto object-contain mb-3" />
          <div className="text-xs uppercase tracking-[0.2em] text-emerald-400">Bienvenue</div>
          <h2 className="font-display font-bold text-xl mt-1">Connexion</h2>
        </div>

        <p className="text-sm text-zinc-400 mb-6">
          Pas de mot de passe à retenir : connectez-vous avec votre compte Google.
        </p>

        <div className="space-y-3">
          <GoogleSignInButton />
          <div className="text-[11px] text-zinc-600 text-center pt-1">
            La connexion avec un compte Apple arrivera prochainement.
          </div>
        </div>

        <p className="mt-8 text-xs text-zinc-500 text-center">
          En vous connectant, vous acceptez nos conditions d'utilisation. Aucun mot de passe n'est stocké — l'authentification est déléguée à Google.
        </p>
      </Card>
    </div>
  );
}
